import {Injectable} from "@angular/core";

@Injectable()
export class GameCredits {
  credits: {[key: string]: string[]} = {'Developped by': ['Daniel Müller']};

  get entries(): [string,string[]][]{
    return Object.entries(this.credits);
  }
}
